import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { setting } from '../../../../setting';


@Injectable()
export class HttpsInterceptor implements HttpInterceptor {
  // URLs que deben mantenerse como HTTP (extraídas del setting)
  private httpUrls: string[] = [];
  
  constructor() {
    // Recopilar todas las URLs HTTP del setting
    this.httpUrls = this.collectHttpUrls(setting);
    console.log('📡 URLs HTTP protegidas:', this.httpUrls);
  }
  
  private collectHttpUrls(obj: any, urls: string[] = []): string[] {
    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        const value = obj[key];
        if (typeof value === 'string' && value.startsWith('http://')) {
          // Guardar la URL base (sin /api, sin /v1, etc.)
          const baseUrl = value.split('/api')[0];
          if (!urls.includes(baseUrl)) {
            urls.push(baseUrl);
          }
        } else if (typeof value === 'object' && value !== null) {
          this.collectHttpUrls(value, urls);
        }
      }
    }
    return urls;
  }
  
  private shouldSkipConversion(url: string): boolean {
    // Verificar si la URL coincide con alguna de las HTTP del setting
    return this.httpUrls.some(httpUrl => url.startsWith(httpUrl));
  }
  
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let url = req.url;
    
    // Solo convertir si NO está en la lista de URLs HTTP
    if (!this.shouldSkipConversion(url) && url.startsWith('http://')) {
      url = url.replace('http://', 'https://');
      console.log(`🔒 Convertiendo: ${req.url} → ${url}`);
      const httpsReq = req.clone({ url });
      return next.handle(httpsReq);
    }
    
    return next.handle(req);
  }
}